import React from "react";
import { Alert } from "antd";
import useLang from "../../../hooks/useLang";
import { getCategoryConfig } from "../../../utils/bulkOperationsConfig";
import BulkOpsHeader from "../components/BulkOpsHeader";
import CategoryCard from "../components/CategoryCard";
import { REPORTS } from "./reportRegistry";

/**
 * The Client Reports category. Unlike the other categories this one is a second picker rather than
 * a screen: it holds three separate reports, so the card grid repeats one level down.
 */
const ClientReports = () => {
	const { strings } = useLang("bulkOrderOperations");
	const common = strings?.common;
	const categoryStrings = strings?.categories?.clientReports;

	const { strings: reportStrings } = useLang("clientReports");

	const categoryConfig = getCategoryConfig("client-reports");

	return (
		<div className="max-w-5xl mx-auto px-4 py-6 flex flex-col gap-6">
			<BulkOpsHeader
				title={categoryStrings?.label ?? "Raporte të Klientëve"}
				subtitle={
					categoryStrings?.description ??
					"Zgjidh raportin që dëshiron të gjenerosh"
				}
				backTo="/bulk-order-operations"
				backLabel={common?.back ?? "Të gjitha kategoritë"}
			/>

			{!categoryConfig && (
				<Alert
					type="error"
					showIcon
					message={
						common?.categoryUnavailable ??
						"This category is not configured for this country."
					}
				/>
			)}

			{/*
			 * The first two reports are easy to conflate and the difference changes who ends up on
			 * a call list, so it is stated once here rather than left to the card descriptions.
			 */}
			<Alert
				type="info"
				showIcon
				message={
					reportStrings?.differenceNote ??
					"Kujdes: “Klientë që kanë ndaluar porositë” filtron porosinë e FUNDIT ndonjëherë — klientë që ikën dhe nuk u kthyen. “Klientë pa porosi në periudhë” gjen një boshllëk — zero porosi brenda datave, pavarësisht çfarë ndodhi para ose pas."
				}
			/>

			<div className="grid grid-cols-1 md:grid-cols-3 gap-3">
				{REPORTS.map((report) => (
					<CategoryCard
						key={report.key}
						label={
							reportStrings?.reports?.[report.stringsKey]
								?.label ?? report.fallbackLabel
						}
						description={
							reportStrings?.reports?.[report.stringsKey]
								?.description ?? report.fallbackDescription
						}
						question={
							reportStrings?.reports?.[report.stringsKey]
								?.question ?? report.fallbackQuestion
						}
						icon={report.icon}
						to={`/bulk-order-operations/client-reports/${report.key}`}
					/>
				))}
			</div>
		</div>
	);
};

export default ClientReports;
